import { BACKEND_BASE_URL, IResponseError } from "@/services";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";
import { IOrderPendingService } from "@/services/backend/order/order.types";
import { CashOrderSendStatusEnum, IRequestHistorialsService } from "@/entities";

export class OrderPendingService implements IOrderPendingService {
  async getPendingOrders(
    servicePointId?: string
  ): Promise<IRequestHistorialsService[] | undefined> {
    const { response, error } = await handleResponse<IRequestHistorialsService[], IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/order/${servicePointId}`)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async getExpiredOrders(
    servicePointId?: string
  ): Promise<IRequestHistorialsService[] | undefined> {
    const { response, error } = await handleResponse<IRequestHistorialsService[], IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/order/expired/${servicePointId}`)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async getPendingSendOrders(
    servicePointId?: string
  ): Promise<IRequestHistorialsService[] | undefined> {
    const { response, error } = await handleResponse<IRequestHistorialsService[], IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/order/pendingSend/${servicePointId}`)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async updateOrderSendStatus(
    orderId: number,
    sendStatus: CashOrderSendStatusEnum
  ): Promise<boolean> {
    const { error } = await handleResponse<unknown, IResponseError>(
      Vue.$axios.patch(
        `${BACKEND_BASE_URL}/api/configuration/v1/order/${orderId}/updateSendStatus`,
        { sendStatus }
      )
    );
    return !error;
  }
}
